/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';

const initialState = {
  isloading: false,
  error: null,
  video: null,
  gallery: [],
};

const slice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    startLoading(state) {
      state.isloading = true;
    },

    hasError(state, action) {
      state.isloading = false;
      state.error = action.payload;
    },

    getMediaGallerySuccess(state, action) {
      state.isloading = false;
      state.gallery = action.payload;
    },

    getMediaVideoSuccess(state, action) {
      state.isloading = false;
      state.video = action.payload;
    },
  },
});

export default slice.reducer;

export const { getMediaGallerySuccess, getMediaVideoSuccess } = slice.actions;

export const CreateOrUpdateVideo = (videoData, Snackbar, navigate) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try {
    await axios.post('/media/video', videoData);
    dispatch(getVideos());
    navigate(PATH_DASHBOARD.general.media.root);
    Snackbar('Succesfully Updated!', 'success');
  } catch (error) {
    Snackbar('Server Error', 'error');
    dispatch(slice.actions.hasError(error));
  }
};

export const getVideos = () => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try {
    const response = await axios.get('/media/video');
    dispatch(slice.actions.getMediaVideoSuccess(response.data.data));
  } catch (error) {
    dispatch(slice.actions.hasError(error));
  }
};

export const getAllImages = (searchParams) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try {
    const response = await axios.get(`/media/gallery?${searchParams}`);
    dispatch(slice.actions.getMediaGallerySuccess(response.data.data));
  } catch (error) {
    dispatch(slice.actions.hasError(error));
  }
};

export const createImages = (images, Alert, reset) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try {
    await axios.post('/media/gallery', images);
    reset();
    Alert();
  } catch (error) {
    dispatch(slice.actions.hasError(error));
  }
};

export const deleteImage = (id, SnackBar) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try {
    await axios.put(`/media/gallery/${id}`);
    dispatch(getAllImages());
    SnackBar('Succesfully deleted!', 'success');
  } catch (error) {
    dispatch(slice.actions.hasError(error));
  }
};
